import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  const attempted = location.pathname;
  const isAppPath = attempted.startsWith("/app/");

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-4" data-testid="not-found-page">
      <div className="max-w-xl w-full text-center border border-zinc-800 rounded-2xl p-10 bg-zinc-950/50">
        <div className="text-7xl mb-4">🥋</div>
        <div className="text-[10px] tracking-[0.4em] text-amber-400 mb-2">PAGE INTROUVABLE · 404</div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">Cette page n'existe pas</h1>
        <p className="text-zinc-400 mt-3">
          L'URL <code className="text-amber-300 bg-black/50 px-2 py-0.5 rounded text-xs font-mono break-all">{attempted}</code> n'est pas une route valide de la plateforme DOJOVA.
        </p>

        {isAppPath && (
          <div className="mt-6 border border-blue-500/30 bg-blue-500/5 rounded-xl p-4 text-left">
            <div className="text-[10px] tracking-[0.3em] text-blue-300 mb-1">💡 NOTE</div>
            <div className="text-xs text-zinc-300">
              Tu as essayé une URL <code className="text-blue-200">/app/...</code>. Vérifie que c'est bien une route du dashboard (ex: <code>/app/billetterie</code>, <code>/app/livestream</code>, <code>/app/operator</code>). Les fichiers internes du serveur (comme <code>/app/memory/...</code>) ne sont pas accessibles via le navigateur.
            </div>
          </div>
        )}

        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link to="/" className="bg-amber-500 hover:bg-amber-400 text-black font-semibold px-5 py-2.5 rounded-full text-sm">
            ← Accueil KAIZEN
          </Link>
          <Link to="/app" className="border border-zinc-700 hover:border-amber-500 hover:text-amber-300 text-zinc-300 px-5 py-2.5 rounded-full text-sm">
            🥋 Tableau de bord
          </Link>
          <Link to="/onboarding" className="border border-zinc-700 hover:border-amber-500 hover:text-amber-300 text-zinc-300 px-5 py-2.5 rounded-full text-sm">
            👋 Onboarding
          </Link>
        </div>

        <div className="mt-10 pt-6 border-t border-zinc-800 text-center text-zinc-500 text-xs">
          <div>Présenté par</div>
          <div className="text-amber-400 mt-1 tracking-[0.2em] font-semibold">Institut Impact Élite Martial · DOJOVA — Kaizen System</div>
        </div>
      </div>
    </div>
  );
}
